import { Dictionary } from 'vuex';

import { Profile } from '@/interfaces/profile';
import { profileResource, ProfileResource } from '@/resources/profile.resource';
import { AbstractModule } from './abstract.module';
import { EntityModule } from './entity.module';
import examResults from './profile/examResult.module';
import medicalExamination from './profile/medicalExamination.module';
import offers from './profile/offers.module';
import roles from './profile/userRole.module';

/**
 * Moduł profilu
 *
 * @export
 * @class ProfileModule
 * @extends {EntityModule<Profile, ProfileResource>}
 */
export class ProfileModule extends EntityModule<Profile, ProfileResource> {
  /**
   * Submoduły profilu
   *  Role, Wnioski
   *
   * @memberof ProfileModule
   */
  public modules: Dictionary<AbstractModule<any>> = { roles, offers, medicalExamination, examResults };

  constructor() {
    super(profileResource);
  }
}

export default new ProfileModule();
